import {Placement} from '@amzn/showtime';

import {
  hasAtoZHVHAppFeature,
  hasHVHCareersFeature,
  hasHVHCareersJobDetail,
  hasHVHCareersLoadMore,
  hasHVHCareersUKPhase3Feature,
  hasHVHCareersAtoZPreferenceCenter,
  hasSalariedAlumniJobs,
  hasJobSearchNativeToWeb,
} from '../features';
import {JOB_CARDS_LOAD_MORE_REQUEST_LIMIT, setJobCardLimit} from '../common/constant';

import FilterScreen from './FilterScreen';
import JobSearchSubsection from './JobSearchSubsection';
import JobSection from './JobSection';
import JobDetailScreen from './JobDetailScreen';
import ScheduleSelectionScreen from './ScheduleSelectionScreen';
import AESSubpagePlacement from './AESSubpagesPlacement';
import CandidateDashboardSubsection from './CandidateDashboardSubsection';
import JobSearchWebSubsection from './JobSearchWebSubsection';
import PreferenceCenterScreen from './PreferenceCenterScreen';

const getPlacements = (features: string[]) => {
  const placements: Placement[] = [];

  if (
    hasHVHCareersFeature(features) ||
    hasSalariedAlumniJobs(features) ||
    hasHVHCareersUKPhase3Feature(features) ||
    hasJobSearchNativeToWeb(features)
  ) {
    placements.push(JobSection);
  }

  if (hasHVHCareersUKPhase3Feature(features) || hasJobSearchNativeToWeb(features)) {
    // UK specific
    placements.push(JobSearchWebSubsection);
  } else if (hasHVHCareersFeature(features)) {
    // US specific
    placements.push(JobSearchSubsection);
    placements.push(FilterScreen);
  }

  if (hasHVHCareersLoadMore(features)) {
    setJobCardLimit(JOB_CARDS_LOAD_MORE_REQUEST_LIMIT);
  }

  if (hasHVHCareersJobDetail(features)) {
    placements.push(JobDetailScreen);
    placements.push(ScheduleSelectionScreen);
  }

  if (hasAtoZHVHAppFeature(features)) {
    placements.push(CandidateDashboardSubsection);
  }

  if (hasHVHCareersAtoZPreferenceCenter(features)) {
    placements.push(PreferenceCenterScreen);
  }

  // Web tenant render as subpage by default, but to resolve full page reload issue, we have to explicitly add subpage placement
  placements.push(AESSubpagePlacement);

  return placements;
};

export default getPlacements;
